// extracted by mini-css-extract-plugin
module.exports =  {"container":"_33974c2b58--container--p0Kgm","message":"_33974c2b58--message--BHjBi","name":"_33974c2b58--name--ovTfh","tooltip-container":"_33974c2b58--tooltip-container--_zs7F"};